import React, { useEffect, useState } from "react";
import "./Footer.css";
import RoyalLogo from "../../../assets/svgs/buildHolidayLogo.svg";
import LogoWhiteRoyalInternational from "../../../assets/svgs/royalInternationalWhite.svg";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { useSelector } from "react-redux";
import { selectCountryCode } from "../../../features/countrySelector/countrySelectorSlice";
import { getUserDetails } from "../../../services/apiRequest";
import moment from "moment";
import { checkIfIsRoyalInternational, getCurrentTranslations } from "../../../utilities/helper";
import translationResources from "../../../utilities/multiLanguage";

const Footer = ({
    showMenu = true,
    absolute = false,
    forceToBeAbsolute = false,
    isCopyRight = false,
}) => {
    // Handle Translations
    const [translations, setTranslations] = useState({});
    useEffect(() => {
        setTranslations(translationResources["footer"][window.currentLanguage]);
    }, []);
    //End ./ Handle Translations

    const navigate = useNavigate();
    const [showDisclaimer, setShowDisclaimer] = useState(false);
    const [isAbsolute, setIsAbsolute] = useState(absolute);
    const isMobile = useMediaQuery({ query: "(max-width: 1024px)" });
    const countryCode = useSelector(selectCountryCode);
    const userDetails = getUserDetails();
    const [travelAgencyUid, setTravelAgencyUid] = useState(null);

    const handleCountryCode = () => {
        if (getUserDetails().user_details?.country === "NORDICS" || countryCode == "NORDICS") {
            return "NORDICS";
        } else if (getUserDetails().user_details?.country === "MT" || countryCode == "MT") {
            return "MT";
        } else if (getUserDetails().user_details?.country === "AE" || countryCode == "AE") {
            return "AE";
        }

        return "";
    };

    const handleTermsAndConditions = () => {
        if (handleCountryCode() === "NORDICS") {
            return "/terms-and-conditions/nordics";
        } else if (handleCountryCode() === "MT") {
            return "/terms-and-conditions/malta";
        } else if (handleCountryCode() === "AE") {
            return "/terms-and-conditions/ae";
        }

        return "/terms-and-conditions";
    };

    const [footerItems, setFooterItems] = useState([
        {
            title: getCurrentTranslations("footer", "contactUs"),
            // link: "https://www.myclubroyal.co.uk/#/contact-us",
            link: "/contact-us",
        },
        {
            title: getCurrentTranslations("footer", "termsAndCondition"),
            link: handleTermsAndConditions(),
        },
        {
            title: getCurrentTranslations("footer", "privacyPolicy"),
            link:
                countryCode == "NORDICS" || userDetails?.user_details?.country == "NORDICS"
                    ? "https://myclubroyal.no/RCCL/pdfs/legal/Privacy_Policy.pdf"
                    : getCurrentTranslations("footer", "privacyPolicyUrl"),
        },
        {
            title: getCurrentTranslations("footer", "cookieInfo"),
            link:
                countryCode == "NORDICS" || userDetails?.user_details?.country == "NORDICS"
                    ? "https://myclubroyal.no/RCCL/pdfs/legal/Cookie_Policy.pdf"
                    : getCurrentTranslations("footer", "cookieInfoUrl"),
        },
    ]);

    useEffect(() => {
        if (isMobile) {
            if (forceToBeAbsolute) {
                setIsAbsolute(forceToBeAbsolute);
                return;
            }
            setIsAbsolute(false);
        } else {
            setIsAbsolute(absolute);

            if (forceToBeAbsolute) {
                setIsAbsolute(true);
            }
        }
    }, [isMobile]);

    useEffect(() => {
        setTravelAgencyUid(userDetails?.user_details?.travel_agency_uid);
    }, [userDetails]);

    // Check if the user is Royal International and edit footer items
    useEffect(() => {
        if (checkIfIsRoyalInternational(travelAgencyUid)) {
            setFooterItems((prevFooterItems) => {
                if (prevFooterItems.length > 1) {
                    return [
                        //...prevFooterItems.slice(0, 1), 
                        {
                            ...prevFooterItems[0], 
                            title: "0344 493 4005",
                            link: "",
                        },
                        {
                            ...prevFooterItems[1], 
                            title: "Terms of Use",
                            link: "https://www.royalcaribbean.com/gbr/en/terms-and-conditions/digital-terms-of-use-and-end-user-license-agreement",
                        },
                        {
                            ...prevFooterItems[2], 
                            title: getCurrentTranslations("footer", "privacyPolicy"),
                            link: "https://www.royalcaribbean.com/gbr/en/resources/privacy-policy",
                        },
                        // ...prevFooterItems.slice(3), // i just removed the last item becuase on the design is not there
                    ];
                }
                return prevFooterItems;
            });
        }
    }, [travelAgencyUid]);

    return (
        <div
            className={`footer__mainContainer  ${
                isAbsolute
                    ? "absolute bottom-0 left-0 w-screen max-w-[120rem]"
                    : "static w-full h-fit mx-auto"
            }`}
        >
            <div
                className={`footer pt-9 pb-12 md:flex md:items-center ${
                    showMenu ? "md:justify-center" : "md:justify-center"
                } md:px-24`}
            >
                {!isCopyRight ? (
                    <>
                        {showMenu && (countryCode || userDetails?.user_details?.country) && (
                            <ul className="flex flex-wrap items-left mr-auto text-md xl:text-xl tracking-[0.113rem] font-darwinProRegular sm:mt-0">
                                {footerItems?.map((item, index) => (
                                    <li key={index} className="mr-12">
                                        <a
                                            href={item.link}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                if (item.isDisclaimer) {
                                                    setShowDisclaimer(!showDisclaimer);
                                                } else {
                                                    if (item.link.includes("https")) {
                                                        window.open(
                                                            item.link,
                                                            "_blank",
                                                            "noopener, noreferrer"
                                                        );
                                                    } else {
                                                        navigate(item.link);
                                                    }
                                                }
                                            }}
                                        >
                                            {item.title}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        )}{" "}
                    </>
                ) : (
                    <div className="footer__copyright">
                        © {moment().format("YYYY")}{" "}
                        {getCurrentTranslations("footer", "textRoyalCaribbeanInternational")}
                    </div>
                )}
                {!isCopyRight && (
                    <img
                        className={`w-[10.25rem] h-[2.625rem] object-contain ${
                            showMenu ? "mt-[2rem] lg:mt-0" : ""
                        }`}
                        src={checkIfIsRoyalInternational(travelAgencyUid) ? LogoWhiteRoyalInternational : RoyalLogo}
                        alt="royal logo"
                    />
                )}
            </div>

            {showMenu && (
                <div className="footer__disclaimer px-[50px] lg:px-24">
                    {getCurrentTranslations("footer", "textDisclaimer")}
                </div>
            )}
        </div>
    );
};

export default Footer;
